<template>
  <div id="users">
    <div class="subheader pb-2 pb-lg-4 subheader-transparent" id="kt_subheader">
      <div
        class="
              container-fluid
              d-flex
              align-items-center
              justify-content-between
              flex-wrap flex-sm-nowrap
            "
      >
        <!--begin::Details-->
        <div class="d-flex align-items-center flex-wrap mr-2">
          <!--begin::Title-->
          <h5
            class="text-dark font-weight-bold mt-2 mb-2 mr-5"
            v-if="!byDepartment"
          >
            {{ $t("menu.controller.users.title") }}
          </h5>
          <h5 v-else>
            {{
              $t("menu.controller.users.byDepartment", {
                department: searchDepartment
              })
            }}
          </h5>
          <!--end::Title-->
          <!--begin::Separator-->
          <div
            class="
                  subheader-separator subheader-separator-ver
                  mt-2
                  mb-2
                  mr-5
                  bg-gray-200
                "
          ></div>
          <!--end::Separator-->
          <!--begin::Search Form-->
          <div class="d-flex align-items-center" id="kt_subheader_search">
            <span class="text-dark-50 font-weight-bold" id="kt_subheader_total"
              >{{ total }}
              {{
                $t("tables.total", {
                  module: $tc("tables.user", total).toLowerCase()
                })
              }}</span
            >
            <div class="ml-5">
              <div
                class="input-group input-group-sm input-group-solid"
                style="max-width: 175px"
              >
                <input
                  type="text"
                  class="form-control"
                  id="search"
                  v-model="search"
                  :placeholder="$t('tables.search') + ' ...'"
                />
                <div class="input-group-append">
                  <span class="input-group-text">
                    <span class="svg-icon">
                      <!--begin::Svg Icon | path:/metronic/theme/html/demo9/dist/assets/media/svg/icons/General/Search.svg-->
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z"/><path d="M14.293 16.707a1 1 0 011.414-1.414l4 4a1 1 0 01-1.414 1.414l-4-4z" fill="#000" fill-rule="nonzero" opacity=".3"/><path d="M11 16a5 5 0 100-10 5 5 0 000 10zm0 2a7 7 0 110-14 7 7 0 010 14z" fill="#000" fill-rule="nonzero"/></g></svg>
                      <!--end::Svg Icon-->
                    </span>
                    <!--<i class="flaticon2-search-1 icon-sm"></i>-->
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!--end::Search Form-->
          <div class="d-flex align-items-center ml-5">
            <!--begin::Profile filter-->
            <b-dropdown
              id="ddown-types"
              :text="$t(`assets.titles.profiles`)"
              class="mr-6"
            >
              <div
                v-for="(element, index) in profilesTypes"
                :key="element.text + index"
                class="dropdown-item bg-white text-body"
              >
                <b-form-checkbox
                  @change="filter(element, 'profilesTypes')"
                  :value="element.value"
                  >{{ element.text }}</b-form-checkbox
                >
              </div>
            </b-dropdown>
            <b-button
              @click="updateMultiUser()"
              variant="light-success"
              class="ml-2 font-weight-bold"
              :disabled="selected.length == 0 && total == 0"
            >
              <i class="la la-pencil pl-1" />
              {{
                $t("assets.buttons.update_users", {
                  users: selected.length == 0 ? total : selected.length
                })
              }}
            </b-button>
            <b-button
              @click="deleteMultiUser()"
              variant="light-danger"
              class="ml-2 font-weight-bold"
              :disabled="selected.length == 0 && total == 0"
            >
              <i class="la la-trash pl-1" />
              {{
                $t("assets.buttons.delete_users", {
                  users: selected.length == 0 ? total : selected.length
                })
              }}
            </b-button>
            <!--end::Profile filter-->
          </div>
        </div>
        <!--end::Details-->
        <!--begin::Toolbar-->
        <div class="d-flex align-items-center">
          <json-excel
            :data="filtered"
            :fields="excelFields"
            v-b-tooltip.bottom.hover
            :title="$t('tables.download')"
            type="xls"
            name="users"
            class="btn btn-light-primary btn-icon ml-3"
          >
            <span class="svg-icon svg-icon-light-primary px-2">
              <simple-svg
                :src="require('@/assets/images/icons/downloaded-file.svg')"
              />
            </span>
          </json-excel>

          <b-button
            @click="sendWellcomeMail"
            variant="light-primary"
            class="ml-2 font-weight-bold"
            v-b-tooltip.bottom.hover
            :disabled="selected.length == 0 && total == 0"
            :title="$tc('tables.sendWellcomeMail')"
          >
            {{ selected.length == 0 ? total : selected.length }}
            <i class="p-0 fa fa-envelope" />
          </b-button>

          <b-button
            @click="$router.push({ name: 'UserCreate' })"
            variant="light-success"
            class="ml-2 font-weight-bold"
            v-b-tooltip.bottom.hover
            :title="$t('tables.create.employee')"
          >
            <i class="p-0 fa fa-plus" />
          </b-button>
        </div>
      </div>
    </div>
    <b-card
      class="card-custom card-stretch card-rounded"
      no-body
      v-if="areUsersLoaded"
    >
      <b-card-body>
        <b-table
          id="users-table"
          hover
          :items="filtered"
          :fields="fields"
          :per-page="perPage"
          :current-page="currentPage"
          primary-key="stakeholderId"
          responsive="sm"
          stacked="sm"
          show-empty
          selectable
          @row-selected="onRowSelected"
          ref="selectableTable"
        >
          <template>
            <empty-search
              :description="$t(`tables.empty.description`)"
              :buttonText="$t(`tables.empty.button`)"
              :action="resetFilters"
            />
          </template>
          <template #cell(selected)="{ rowSelected }">
            <i v-if="rowSelected" class="fa fa-check" />
          </template>
          <template #cell(profiles)="row">
            {{ getUserProfiles(row.item) }}
          </template>
          <template #cell(actions)="row">
            <b-button
              pill
              variant="light-primary"
              class="mr-2 px-auto"
              @click="updateUser(row.item.stakeholderId)"
            >
              <i class="la la-pencil pl-1" />
            </b-button>
            <b-button
              pill
              variant="light-danger"
              class="mr-2 px-auto"
              @click="deleteUser(row.item)"
            >
              <i class="la la-trash pl-1" />
            </b-button>
          </template>
        </b-table>
        <div class="flex-wrap mx-auto" v-if="total > 0">
          <b-pagination
            class="d-flex flex-wrap mt-3 py-2 mr-3"
            v-model="currentPage"
            :total-rows="total"
            :per-page="perPage"
            aria-controls="users-table"
            first-number
            pill
            last-number
            align="center"
            size="lg"
          >
          </b-pagination>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters, mapActions } from "vuex";
import {
  deleteStakeholder,
  deleteStakeholders,
  sendWellcomeMail
} from "@/api/admin/stakeholders.api";

import EmptySearch from "@/components/EmptySearch.component.vue";
import JsonExcel from "vue-json-excel";
import { SimpleSVG } from "vue-simple-svg";

export default {
  name: "UsersList",
  components: {
    EmptySearch,
    JsonExcel,
    "simple-svg": SimpleSVG
  },
  data() {
    return {
      perPage: 10,
      grid: true,
      currentPage: 1,
      search: "",
      byDepartment: false,
      searchDepartment: "",
      profilesTypes: [
        { text: this.$t("menu.toggle.filter.employee"), value: "USER" },
        { text: this.$t("menu.toggle.filter.controller"), value: "CONTROLLER" },
        { text: this.$t("menu.toggle.filter.admin"), value: "ADMIN" }
      ],
      activeFilters: {
        profilesTypes: []
      },
      allSelected: false,
      selected: []
    };
  },
  computed: {
    ...mapGetters("Constants", ["isConstantsActive"]),
    ...mapGetters("Admin", ["areUsersLoaded", "users"]),
    ...mapGetters("Auth", ["hasModule"]),
    fields() {
      let fields = [
        {
          key: "selected",
          label: this.$tc("tables.selected", 1),
          sortable: false,
          class: "align-middle"
        },
        {
          key: "name",
          label: this.$tc("tables.name", 1),
          sortable: true,
          sortByFormatted: true,
          class: "align-middle text-left",
          formatter: (val, key, item) => {
            return item.name + " " + item.surname;
          }
        },
        {
          key: "department",
          label: this.$tc("tables.department", 1),
          sortable: true,
          sortByFormatted: true,
          class: "align-middle text-left",
          formatter: (val, key, item) => {
            return item.stakeholderDepartmentName;
          }
        },
        {
          key: "email",
          label: this.$tc("tables.email", 1),
          sortable: true,
          sortByFormatted: true,
          class: "align-middle text-left"
        },
        {
          key: "profiles",
          label: this.$tc("tables.profiles", 1),
          sortable: false,
          sortByFormatted: true,
          class: "align-middle text-left"
        },
        {
          key: "actions",
          label: this.$t("tables.actions"),
          sortable: false,
          class: "align-middle"
        }
      ];
      return _.filter(fields, item => {
        return item.service === undefined || this.hasModule([item.service]);
      });
    },
    excelFields() {
      var fields = {};
      fields[this.$tc("tables.name", 1)] = {
        name: "name",
        callback: value => value.name
      };
      fields[this.$tc("tables.surname", 1)] = {
        name: "surname",
        callback: value => value.surname
      };
      fields[this.$tc("tables.email")] = {
        name: "email",
        callback: value => value.email
      };
      fields[this.$tc("tables.department", 1)] = {
        name: "department",
        callback: value => value.stakeholderDepartmentName
      };
      return fields;
    },
    total() {
      let users = this.users;
      if (this.activeFilters.profilesTypes.length > 0) {
        users = _.filter(users, user => {
          return Object.keys(user.profiles).some(profile =>
            this.activeFilters.profilesTypes.includes(profile)
          );
        });
      }
      if (this.byDepartment !== false) {
        users = _.filter(users, user => {
          if (user.stakeholderDepartmentId === this.$route.query.department) {
            this.searchDepartment = user.stakeholderDepartmentName;
            return true;
          } else {
            return false;
          }
        });
      }
      if (this.search !== "") {
        const regex = new RegExp(`\\b${this.search}`, "i");
        users = _.filter(users, user => {
          return (
            regex.test(user.name + " " + user.surname) ||
            regex.test(user.stakeholderDepartmentName) ||
            regex.test(user.email)
          );
        });
      }
      return _.size(users);
    },
    filtered() {
      let users = this.users;
      if (this.activeFilters.profilesTypes.length > 0) {
        users = _.filter(users, user => {
          return Object.keys(user.profiles).some(profile =>
            this.activeFilters.profilesTypes.includes(profile)
          );
        });
      }
      if (this.byDepartment !== false) {
        users = _.filter(users, user => {
          if (user.stakeholderDepartmentId === this.$route.query.department) {
            this.searchDepartment = user.stakeholderDepartmentName;
            return true;
          } else {
            return false;
          }
        });
      }
      if (this.search !== "") {
        const regex = new RegExp(`\\b${this.search}`, "i");
        users = _.filter(users, user => {
          return (
            regex.test(user.name + " " + user.surname) ||
            regex.test(user.stakeholderDepartmentName) ||
            regex.test(user.email)
          );
        });
      }

      return this.grid ? _.slice(users, 0, this.showing) : users;
    }
  },
  methods: {
    ...mapActions("Admin", ["loadCompanySelected", "reset", "loadUsers"]),
    sendWellcomeMail() {
      let users = this.selected.length == 0 ? this.filtered : this.selected;
      this.$swal({
        html:
          this.$t("admin.popup.send_wellcome_mail.question", {
            users: users.length
          }) +
          "<br>" +
          "<br>" +
          this.$t("admin.popup.send_wellcome_mail.sendConfirm", {
            word: this.$t("admin.popup.send_wellcome_mail.answer")
          }),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#0BB783",
        confirmButtonText: this.$t("admin.popup.confirmButton"),
        cancelButtonText: this.$t("admin.popup.cancelButton"),
        input: "text",
        inputValidator: value => {
          if (value === this.$t("admin.popup.send_wellcome_mail.answer")) {
            let stakeholdersId = _.map(users, element => element.stakeholderId);
            sendWellcomeMail(
              localStorage.getItem("managedCompanyId"),
              stakeholdersId
            ).then(response => {
              this.$root.$bvToast.toast(
                this.$t("admin.form.success.send_wellcome_mail_body", {
                  users: response.data.records.length
                }),
                {
                  title: this.$t(
                    "admin.form.success.send_wellcome_mail_header"
                  ),
                  variant: "success",
                  solid: true,
                  toaster: "b-toaster-top-center"
                }
              );
            });
          } else {
            return this.$t("admin.popup.incorrectWord");
          }
        }
      });
    },
    onRowSelected(items) {
      this.selected = items;
    },
    filter(id, type) {
      _.includes(this.activeFilters[type], id.value)
        ? (this.activeFilters[type] = _.reject(
            this.activeFilters[type],
            el => el === id.value
          ))
        : this.activeFilters[type].push(id.value);
    },
    updateUser(stakeholderId) {
      this.$router.push({
        name: "UserUpdate",
        query: { type: "single" },
        params: {
          id: stakeholderId
        }
      });
    },
    updateMultiUser() {
      let users = this.selected.length == 0 ? this.filtered : this.selected;
      this.$router.push({
        name: "UserUpdate",
        query: { type: "multiple" },
        params: {
          users: _.map(users, element => element.stakeholderId)
        }
      });
    },
    deleteMultiUser() {
      let users = this.selected.length == 0 ? this.filtered : this.selected;

      this.$swal({
        html: this.$t("admin.popup.delete.multi_user", {
          users: users.length,
          confirmation: this.$t("admin.popup.delete.delete_confirmation")
        }),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#0BB783",
        confirmButtonText: this.$t("admin.popup.confirmButton"),
        cancelButtonText: this.$t("admin.popup.cancelButton"),
        input: "text",
        inputValidator: value => {
          if (value === this.$t("admin.popup.delete.delete_confirmation")) {
            let stakeholdersId = _.map(users, element => element.stakeholderId);
            deleteStakeholders("people", stakeholdersId).then(() => {
              this.loadCompanySelected();
              this.loadUsers();
            });
          } else {
            return this.$t("admin.popup.incorrectWord");
          }
        }
      });
    },
    deleteUser(stakeholder) {
      this.$swal({
        html:
          this.$t("admin.popup.delete.user") +
          "<br>" +
          stakeholder.name +
          " " +
          stakeholder.surname,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#0BB783",
        confirmButtonText: this.$t("admin.popup.confirmButton"),
        cancelButtonText: this.$t("admin.popup.cancelButton")
      }).then(result => {
        if (result.isConfirmed) {
          deleteStakeholder("people", stakeholder.stakeholderId).then(() => {
            this.loadCompanySelected();
            this.loadUsers();
          });
        }
      });
    },
    resetFilters() {
      this.search = "";
    },
    getUserProfiles(item) {
      let profiles = [];
      _.each(Object.keys(item.profiles), profile => {
        if (
          item.profiles[profile].includes(
            Number(localStorage.getItem("managedCompanyId"))
          )
        ) {
          _.isEqual(profile.toLowerCase(), "controller")
            ? profiles.push("O")
            : profiles.push(profile.slice(0, 1));
        }
      });

      return profiles.join("/");
    }
  },
  mounted() {
    if (this.isConstantsActive && !this.areUsersLoaded) this.loadUsers();
    if (this.$route.query.department) this.byDepartment = true;
  },
  watch: {
    isConstantsActive(value) {
      if (value === true) this.loadUsers();
    },
    areUsersLoaded(value) {
      if (this.isConstantsActive && value === false) this.loadUsers();
    }
  }
};
</script>
